import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { TextButton } from '../TextButton';
import styles from './FilterPickerGroup.module.scss';
export function FilterPickerGroup(props) {
    const { className, style, children, flexWrap, onClearClick, disableClear, testId, clearLabel = 'Clear' } = props;
    return /*#__PURE__*/ _jsxs("div", {
        style: style,
        className: cn(styles.root, {
            [styles.flexWrap]: flexWrap
        }, className),
        "data-testid": testId,
        children: [
            children,
            onClearClick ? /*#__PURE__*/ _jsx(TextButton, {
                onClick: onClearClick,
                skin: "secondary",
                disabled: disableClear,
                testId: "".concat(testId, "-clear"),
                bi: {
                    name: 'clear_filters'
                },
                children: clearLabel
            }) : null
        ]
    });
}
